import { useContext } from "react";
import { MenuStatusContext } from "../../context/MenuContext";

// Aviso de "o menu pode estar desatualizado" - pedido do usuário, 2026-10-26:
// alguns aparelhos falhavam em buscar o menu dinâmico da API e ficavam
// mostrando o menu estático hardcoded (menuConfig.js) sem avisar nada, o que
// podia abrir rotas/links errados (desatualizados em relação ao que está
// configurado no CozimaxERP). MenuContext.jsx já troca pelo último cache real
// quando possível e tenta de novo sozinho algumas vezes - isto aqui só
// mostra pro usuário quando mesmo assim não conseguiu, com um jeito manual
// de tentar de novo.
export default function MenuErrorAlert() {
    const { erro, recarregar } = useContext(MenuStatusContext);

    if (!erro) return null;

    return (
        <div
            onClick={recarregar}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                background: "#b8860b",
                color: "white",
                textAlign: "center",
                padding: "10px",
                zIndex: 9998,
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
            }}
        >
            ⚠️ Não foi possível atualizar o menu — alguns itens podem estar desatualizados. Toque para tentar de novo.
        </div>
    );
}
